import React from 'react';
import LogoSVG from "../../img/dipartimento-protezione-civile.svg";
import LogoUE from "../../img/logo_finanziato_dallunione_europea_pnrr.png";
import LogoITA from "../../img/logo_italiadomani_pnrr.png";
import LogoPNRR from "../../img/dpc-logo-mini.png";
import SvgIconDPC from "../dpc-svg-icon";

export default class DpcFooter extends React.Component {

    constructor(props) {
        super(props);
        this.setCookie = this.setCookie.bind(this);
        this.state = {checkCookie: typeof document !== `undefined` && !document.cookie.match(/^(.*;)?\s*cookies_consent\s*=\s*[^;]+(.*)?$/)}
    }


    getDomain() {
        if (typeof window !== `undefined`) {
            const hostnameArray = window.location.hostname.split('.')
            if(hostnameArray.length === 3) {
                const numberOfSubdomains = hostnameArray.length - 2;
                return hostnameArray.length === 2 ? window.location.hostname : hostnameArray.slice(numberOfSubdomains).join('.')
            } else {
                const numberOfSubdomains = hostnameArray.length - 3;
                return hostnameArray.length === 1 ? window.location.hostname : hostnameArray.slice(numberOfSubdomains).join('.')
            }
        }
    }


    setCookie(check) {
        if (typeof document !== `undefined`) {
            if (document.cookie.indexOf('cookies_consent=true') >= 0 && !check) {
                document.cookie = 'cookies_consent=; Path=/; Expires=' + new Date().toUTCString() + ';';
            }
            var date = new Date();
            date.setTime(date.getTime() + (90 * 24 * 60 * 60 * 1000));
            const expires = "; expires=" + date.toUTCString();
            document.cookie = "cookies_consent=" + (check ? "true" : "false") + expires + ";domain=" + this.getDomain() + "; path=/; SameSite=Lax";
            console.log("cookies_consent=" + (check ? "true" : "false") + expires + ";domain=" + this.getDomain() + "; path=/; SameSite=Lax");
            window.location.reload();
        }
    }

    geFooterLinkBasePath = () => {
        if (this.props.portaleUrl) {
            return `${this.props.portaleUrl}/${this.props.lang}`
        } else {
            return `/${this.props.lang}`
        }
    }

    getCookie = () => {
        if (typeof document !== `undefined`) {
            return !!document.cookie.indexOf('cookies_consent=true') >= 0;
        }
        return false;
    }

    render() {
        return (
            <>
                <footer className="it-footer" role="contentinfo" id="footer" tabIndex="-1">
                    {this.props.isHomepagePortale &&
                    <div className="it-footer-share-social">
                        <div className="container">
                            <div className="px-custom py-3">
                                {!this.state.checkCookie &&
                                <div className="it-socials d-flex justify-content-end">
                                    <span>{this.props.lang === 'it' ? 'Condividi su' : "Share"}</span>
                                    <ul>
                                        <li>
                                            <a href={`https://www.facebook.com/sharer/sharer.php?u=${this.props.portaleUrl}/${this.props.lang}`}
                                               title="Condividi su Facebook" target="_blank" rel="noreferrer">
                                                <SvgIconDPC name={'facebook'}/>
                                            </a>
                                        </li>
                                        <li>
                                            <a href={`https://twitter.com/intent/tweet?url=${this.props.portaleUrl}/${this.props.lang}`}
                                               title="Condividi su Twitter" target="_blank" rel="noreferrer">
                                                <SvgIconDPC name={'twitter'}/>
                                            </a>
                                        </li>
                                        <li>
                                            <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${this.props.portaleUrl}/${this.props.lang}`}
                                               title="Condividi su Linkedin" target="_blank" rel="noreferrer">
                                                <SvgIconDPC name={'linkedin'}/>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                    }
                    {this.props.isPnrr &&
                    <div class="content-featured-bottom-second">
                        <div class="container clearfix">
                            <div class="px-custom">
                                <div class="content">
                                    <div class="wrapper d-flex justify-content-center">
                                        <div class="item">
                                            <a href="https://europa.eu/next-generation-eu/index_it"
                                            target="_blank">
                                                <img src={LogoUE}
                                                    width="325" height="86"
                                                    alt="Finanziato dell'Unione europea NextGenerationEU"
                                                    title="Finanziato dell'Unione europea NextGenerationEU"
                                                    loading="lazy"/>
                                            </a>
                                        </div>
                                        <div class="item">
                                            <a href="https://www.protezionecivile.gov.it/it/" 
                                            target="_blank">
                                                <img src={LogoPNRR}
                                                    width="279" height="86"
                                                    alt="Dipartimento della Protezione Civile"
                                                    title="Dipartimento della Protezione Civile" loading="lazy"/>
                                            </a>
                                        </div>
                                        <div class="item">
                                            <a href="https://italiadomani.gov.it/it/home.html"
                                            target="_blank">
                                                <img src={LogoITA}
                                                    width="400" height="86"
                                                    alt="Italia Domani, il Piano Nazionale di Ripresa e Resilienza"
                                                    title="Italia Domani, il Piano Nazionale di Ripresa e Resilienza"
                                                    loading="lazy"/>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="clearfix text-formatted">
                                        <p>I punti di vista e le opinioni espresse sono tuttavia
                                            solo quelli degli autori e non riflettono
                                            necessariamente quelli dell'Unione europea o della
                                            Commissione europea.<br/>
                                            Né I'Unione europea né la Commissione europea possono
                                            essere ritenute responsabili per essi.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    }
                    <div className="it-footer-main">
                        <div className="container">
                            <div className="px-custom">
                                <nav aria-label="footer">
                                    <div className="row">
                                        <div className="col-12 col-md-6 col-xl-2">
                                            <h3 className="sr-only">Dipartimento della Protezione Civile</h3><img
                                            src={LogoSVG} className="logo-footer"
                                            alt="Dipartimento Protezione Civile"/>
                                        </div>
                                        <div className="col-12 col-md-6 col-xl-9 offset-xl-1">
                                            <div className="row">
                                                {
                                                    this.props.menuItems.filter(item => item.title.toLowerCase() !== 'homepage').sort((a, b) => {
                                                        return a.weight > b.weight ? 1 : -1;
                                                    }).map((item, i) => {
                                                        if(item.children.length > 0)
                                                            return (
                                                                <div className="col-12 col-lg-4 pb-2">
                                                                    <h4>
                                                                        {item.title}
                                                                    </h4>
                                                                    {
                                                                        item.children.length > 0 && (
                                                                            <div className="link-list-wrapper">
                                                                                <ul className="footer-list link-list clearfix">
                                                                                    {
                                                                                        item.children.sort((a, b) => {
                                                                                            return a.weight > b.weight ? 1 : -1;
                                                                                        }).map(child =>
                                                                                            <li>
                                                                                                <a className="list-item"
                                                                                                   href={child.link}>{child.title}</a>
                                                                                            </li>
                                                                                        )
                                                                                    }
                                                                                </ul>
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            )
                                                        }
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </nav>
                                <section className="pt-5 px-0 border-white border-top">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="row">
                                                <div className="col-12 col-md-4 col-xl-3 offset-xl-3 pb-4">
                                                    <h4>{this.props.lang === 'it' ? 'Sedi' : 'Premises'}</h4>
                                                    <div className="link-list-wrapper">
                                                        <ul className="footer-list link-list clearfix">
                                                            <li>
                                                                <div>
                                                                    <h5>{this.props.lang === 'it' ? 'Sede istituzionale' : 'Historical premises'}</h5>
                                                                    <p>{this.props.lang === 'it' ? 'Via Ulpiano, 11 - 00193 Roma' : 'Via Ulpiano, 11 - 00193 Rome'}</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div>
                                                                    <h5>{this.props.lang === 'it' ? 'Sede operativa' : 'Operative premises'}</h5>
                                                                    <p>{this.props.lang === 'it' ? 'Via Vitorchiano, 2 - 00189 Roma' : 'Via Vitorchiano, 2 - 00189 Rome'}</p>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-4 col-xl-3 pb-4">
                                                    <h4>{this.props.lang === 'it' ? 'Contatti' : 'Contacts'}</h4>
                                                    <div className="link-list-wrapper">
                                                        <ul className="footer-list link-list clearfix">
                                                            <li>
                                                                <div>
                                                                    <h5>{this.props.lang === 'it' ? 'Centralino' : 'Switchboard number'}</h5>
                                                                    <p>(+39) 06 68201</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div>
                                                                    <h5>Contact Center</h5>
                                                                    <p>800 840 840</p>
                                                                    <p><a
                                                                        href={this.props.lang === 'it' ? `${this.props.portaleUrl ? this.props.portaleUrl : ''}/it/dipartimento/contact-center/scrivi-al-contact-center/` : `${this.props.portaleUrl ? this.props.portaleUrl : ''}/en/department/contact-center/write-contact-center/`}
                                                                        title="Vai alla pagina: Scrivi al Contact Center">
                                                                        {this.props.lang === 'it' ? 'Scrivi al Contact Center' : 'Write to Contact Center'}</a>
                                                                    </p>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-4 col-xl-3 pb-4">
                                                    <h4>{this.props.lang === 'it' ? 'Indirizzi di posta elettronica' : 'Email'}</h4>
                                                    <h5>{this.props.lang === 'it' ? 'Posta elettronica certificata' : 'Certified mail'} PEC</h5>
                                                    <p><a href="mailto:protezionecivile@pec.governo.it"
                                                          title="Invia email via Posta Elettronica Certificata PEC">protezionecivile@pec.governo.it</a>
                                                    </p>
                                                    <h4 className="follow-us-title">{this.props.lang === 'it' ? 'Seguici su' : 'Follow us'}</h4>
                                                    <ul className="list-inline text-left social">
                                                        <li className="list-inline-item"><a
                                                            href="https://www.facebook.com/DPCgov/" target="_blank" rel="noreferrer">
                                                            <SvgIconDPC name="facebook" color="#fff"/>
                                                            <span className="sr-only">Facebook</span></a></li>
                                                        <li className="list-inline-item"><a
                                                            href="https://twitter.com/dpcgov" target="_blank" rel="noreferrer">
                                                            <SvgIconDPC name="twitter" color="#fff"/>
                                                            <span className="sr-only">Twitter</span></a></li>
                                                        <li className="list-inline-item"><a
                                                            href="https://www.youtube.com/channel/UC4fru33Tzpu0UhCIHChiNFA"
                                                            target="_blank" rel="noreferrer">
                                                            <SvgIconDPC name="youtube" color="#fff"/>
                                                            <span className="sr-only">YouTube</span></a></li>
                                                        <li className="list-inline-item"><a
                                                            href="https://www.flickr.com/photos/141202146@N02/albums"
                                                            target="_blank" rel="noreferrer">
                                                            <SvgIconDPC name="flickr" color="#fff"/>
                                                            <span className="sr-only">Flickr</span></a></li>
                                                    </ul>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                    <div className="it-footer-small-prints clearfix">
                        <div className="container">
                            <div className="px-custom">
                                <h4 className="sr-only">Sezione Link Utili</h4>
                                <ul className="it-footer-small-prints-list list-inline d-flex flex-column flex-md-row">
                                    <li className="list-inline-item rss"><a href={this.geFooterLinkBasePath() + '/rss/'}
                                                                            title="Iscriviti agli RSS del Dipartimento della Protezione Civile"><abbr
                                        title="Really Simple Syndication">
                                        <svg width="2em" height="2em" viewBox="0 0 16 16" className="bi bi-rss"
                                             aria-hidden="true"
                                             fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                            <path fillRule="evenodd"
                                                  d="M2.5 3.5a1 1 0 0 1 1-1c5.523 0 10 4.477 10 10a1 1 0 1 1-2 0 8 8 0 0 0-8-8 1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1 6 6 0 0 1 6 6 1 1 0 1 1-2 0 4 4 0 0 0-4-4 1 1 0 0 1-1-1z"/>
                                        </svg>
                                        RSS</abbr></a></li>
                                    {(this.props.menuFooterItems && Array.isArray(this.props.menuFooterItems) && this.props.menuFooterItems.length > 0) &&
                                    this.props.menuFooterItems.sort((a, b) => {
                                        return a.node?.weight > b.node?.weight ? 1 : -1;
                                    }).map(item =>
                                        <li className="list-inline-item"><a
                                            href={`${this.geFooterLinkBasePath()}${item.node?.relationships?.field_link_menu?.fields?.slug}`}>{item.node?.name}</a>
                                        </li>
                                    )
                                    }
                                    {/*
                                    <li className="list-inline-item"><a
                                        href={"#"}id="ot-sdk-btn" className="ot-sdk-show-settings"></a>
                                    </li>
                                    */}
                                    <li className="list-inline-item"><a
                                        href={this.geFooterLinkBasePath() + '/sitemap/'}>{this.props.lang === 'it' ? 'Mappa' : 'Map'}</a>
                                    </li>
                                    <li className="list-inline-item"><a
                                        href=" https://form.agid.gov.it/view/ed4c556a-3efa-4979-8f42-d4c333a0e2b5">{this.props.lang === 'it' ? 'Dichiarazione di accessibilità' : 'Accessibility statement'}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </footer>
                {this.state.checkCookie ?
                    <div className={`cookiebar bg-dark p-4 show`}
                         aria-hidden="true">
                        <div className="container">
                            <div className="px-custom">
                                <div className="row d-flex align-items-center">
                                    <div className="col-12 col-md-9" style={{'text-align': 'justify'}}>
                                        <span className="text-white small">
                                            {this.props.lang === 'it'
                                                ? 'Questo sito utilizza cookies tecnici, cookie analytics e cookie di terze parti (altri siti e piattaforme web) per la personalizzazione della home page, il monitoraggio delle visite al sito, la condivisione dei contenuti sui social network, la compilazione automatica di moduli e/o la visualizzazione di contenuti multimediali. Per maggiori informazioni consulta la privacy policy Acconsenti all\'utilizzo di cookie di terze parti?'
                                                : 'This website uses technical and analytical cookies, also from third parties (other websites and web platforms), for the home page customization, visitor monitoring, content sharing on social networks, automatic form filling and/or multimedia content visualization. For further information please consult the privacy policy. Do you agree to the use of third party cookies?'}
                                        </span>
                                    </div>
                                    <div className="col-12 col-md-3 mt-4 mt-md-0 d-flex justify-content-end">
                                        <a className="btn btn-link" href="https://www.protezionecivile.gov.it/it/approfondimento/privacy/">Privacy policy</a>
                                        <button className="btn btn-primary mr-2" onClick={() => {
                                            this.setCookie(true)
                                        }}>{this.props.lang === 'it' ? 'Accetto' : 'I agree'}
                                        </button>
                                        <button className="btn btn-secondary mr-2 cookies-consent-reject"
                                                id="cookiesConsentReject" onClick={() => {
                                            this.setCookie(false)
                                        }}>{this.props.lang === 'it' ? 'Rifiuto' :  'I do not agree'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                                    </div> : null}
            </>)
    }

}
